import instance, { authenticatedInstance } from 'api';
import { triggerToast, triggerModalOpen } from 'redux/actions/ui';
import { loadProfile, loginSuccessful } from 'redux/actions/profile';
import qs from 'qs';

export const GAUTH_REQUEST = {
  STARTED: 'GAUTH_REQUEST_STARTED',
  SUCCESS: 'GAUTH_REQUEST_SUCCESS',
  FAIL: 'GAUTH_REQUEST_FAIL',
};

export const GAUTH_ENABLE = {
  STARTED: 'GAUTH_ENABLE_STARTED',
  SUCCESS: 'GAUTH_ENABLE_SUCCESS',
  FAIL: 'GAUTH_ENABLE_FAIL',
};

export const GAUTH_DISABLE = {
  STARTED: 'GAUTH_DISABLE_STARTED',
  SUCCESS: 'GAUTH_DISABLE_SUCCESS',
  FAIL: 'GAUTH_DISABLE_FAIL',
};

export const GAUTH_GET = {
  STARTED: 'GAUTH_GET_STARTED',
  SUCCESS: 'GAUTH_GET_SUCCESS',
  FAIL: 'GAUTH_GET_FAIL',
};

export const requestGauth = () => {
  return async (dispatch) => {
    dispatch({ type: GAUTH_REQUEST.STARTED });

    try {
      const { data } = await authenticatedInstance({
        url: '/api/GAuth_Enable_Request',
        method: 'GET',
      });

      if (data.status === 'Success') {
        dispatch({
          type: GAUTH_REQUEST.SUCCESS,
          payload: {
            pairingCode: data.data.pairingCode,
            qrCode: data.data.qR_Code,
          },
        });
      } else {
        dispatch({ type: GAUTH_REQUEST.FAIL });
        // dispatch(triggerToast('somethingWentWrong'));
      }
    } catch (data) {
      dispatch({ type: GAUTH_REQUEST.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const enableGauth = (authCode) => {
  return async (dispatch) => {
    dispatch({ type: GAUTH_ENABLE.STARTED });

    try {
      const { data } = await authenticatedInstance({
        url: '/api/GAuth_Set_Enable',
        method: 'POST',
        data: authCode,
      });

      if (data.status === 'Success') {
        dispatch({ type: GAUTH_ENABLE.SUCCESS });
        dispatch(triggerToast('2faEnabled', 'success', 1200));
        dispatch(loadProfile());
      } else {
        dispatch({ type: GAUTH_ENABLE.FAIL });
        dispatch(triggerModalOpen(data.message));
      }
    } catch (e) {
      dispatch({ type: GAUTH_ENABLE.FAIL });
      dispatch(triggerModalOpen('somethingWentWrong'));
    }
  };
};

export const disableGauth = (authCode) => {
  return async (dispatch) => {
    dispatch({ type: GAUTH_DISABLE.STARTED });

    try {
      const { data } = await authenticatedInstance({
        url: '/api/GAuth_Disable_Request',
        method: 'POST',
        data: authCode,
      });

      if (data.status === 'Success') {
        dispatch({ type: GAUTH_DISABLE.SUCCESS });
        dispatch(triggerToast('2faDisabled', 'success', 1200));
        dispatch(loadProfile());
        dispatch(requestGauth());
      } else {
        dispatch({ type: GAUTH_DISABLE.FAIL });
        dispatch(triggerModalOpen(data.message));
      }
    } catch (e) {
      dispatch({ type: GAUTH_DISABLE.FAIL });
      dispatch(triggerModalOpen('somethingWentWrong'));
    }
  };
};

export const get2FAGauth = (authCode) => {
  return async (dispatch, getState) => {
    dispatch({ type: GAUTH_GET.STARTED });

    try {
      const { tempAuthToken } = getState().auth;
      const body = {
        grant_type: 'password',
        username: tempAuthToken,
        password: authCode.GAuth_Code,
      };
      if (localStorage.getItem('deviceId')) {
        body.dvc_id = localStorage.getItem('deviceId');
      }
      const data = await instance({
        url: '/token/v2',
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify(body),
      });

      if (data.status === 200) {
        dispatch(loginSuccessful(data.data.access_token));
        // dispatch(getAdditionalFields());
        // dispatch(getUserTradingVolumeDiscounts());
        // dispatch(callRenewTokenFun());
      } else {
        dispatch({ type: GAUTH_GET.FAIL });
        dispatch(triggerModalOpen(data.data.error_description));
      }
    } catch (e) {
      dispatch({ type: GAUTH_GET.FAIL });
      dispatch(triggerModalOpen('somethingWentWrong'));
    }
  };
};
